import { ChargePointHasSubscription } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-has-subscription.enum';
import { useTranslation } from 'react-i18next';

import { BooleanTriStateFilterController } from '@shared/filter/boolean-tri-state-filter/boolean-tri-state-filter.controller';

interface ChargePointHasSubscriptionFilterControllerProps {
  // null (not undefined) represents "All" — react-hook-form's Controller
  // falls back to its mount-time default whenever the live value is
  // undefined, so an explicit clear must never be undefined.
  onChange: (value: boolean | null) => void;
  selectedItem?: boolean | null;
}

const backgroundColorByState: Record<ChargePointHasSubscription, string> = {
  [ChargePointHasSubscription.TRUE]: 'bg-surface-success',
  [ChargePointHasSubscription.FALSE]: 'bg-surface-error',
  [ChargePointHasSubscription.ALL]: 'bg-surface-brand-secondary',
};

export const ChargePointHasSubscriptionFilterController = ({
  onChange,
  selectedItem,
}: ChargePointHasSubscriptionFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const options = Object.values(ChargePointHasSubscription).map((state) => ({
    key: state,
    label: t(
      `delmonicos-shared-sdk.outputs-charge-point-has-subscription.${state}`,
    ),
    value:
      state === ChargePointHasSubscription.TRUE
        ? true
        : state === ChargePointHasSubscription.FALSE
          ? false
          : null,
    colorClassName: backgroundColorByState[state],
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <BooleanTriStateFilterController
      iconName="receipt-check"
      text={t('delmonicos-shared-sdk.outputs-charge-point.has-subscription')}
      options={options}
      selectedItem={selectedItem}
      onChange={onChange}
    />
  );
};
